// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__eDHiR","skeletonTitle":"Skeleton_skeletonTitle__ec5bb"};